
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Info } from "lucide-react";

interface CoachCardProps {
  coach: any;
  onSelect: (coach: any) => void;
  isMobile: boolean;
}

export const CoachCard = ({ coach, onSelect, isMobile }: CoachCardProps) => {
  return (
    <div 
      className="group relative cursor-pointer"
      onClick={() => onSelect(coach)}
    >
      <Card className="overflow-hidden h-full">
        <div className="relative aspect-[3/4]">
          <img
            src={"/coaches/" + coach.photo_url + ".jpg" || "/coaches/missing.jpg"}
            alt={coach.name_surname}
            className="w-full h-full object-cover object-center"
            onError={(e) => {
              (e.target as HTMLImageElement).src = "/coaches/missing.jpg";
            }}
          />
          {coach.remaining_slots !== null && (
            coach.remaining_slots === 0 ? (
              <Badge 
                variant="destructive" 
                className="absolute top-2 right-2 px-2 py-1 text-xs font-medium"
              >
                Kontenjan doldu
              </Badge>
            ) : coach.remaining_slots <= 3 ? (
              <Badge 
                variant="destructive" 
                className="absolute top-2 right-2 px-2 py-1 text-xs font-medium"
              >
                {coach.remaining_slots === 1 
                  ? "Son kontenjan!" 
                  : `Son ${coach.remaining_slots} kontenjan`}
              </Badge>
            ) : null
          )}
        </div>
        <CardContent className={`p-3 ${isMobile ? 'space-y-2' : 'p-4'}`}>
          <h3 className={`font-semibold ${isMobile ? 'text-sm' : 'text-lg'} mb-2`}>
            {coach.name_surname}
          </h3>
          <div className={`bg-primary/5 rounded-lg ${isMobile ? 'p-2' : 'p-3'} mb-2`}>
            <p className={`${isMobile ? 'text-sm' : 'text-base'} font-medium text-primary mb-1`}>
              {coach.university}
            </p>
            <p className={`${isMobile ? 'text-xs' : 'text-sm'} text-muted-foreground`}>
              {coach.major}
            </p>
          </div>
          <div className="flex flex-wrap gap-1 mb-2">
            {coach.placement_types && coach.placement_ranks && 
              coach.placement_types.map((type: string, index: number) => (
                <div 
                  key={`${type}-${index}`} 
                  className={`bg-white shadow-sm rounded-lg ${isMobile ? 'px-2 py-1 text-xs' : 'px-3 py-1.5 text-sm'}`}
                >
                  <span className="font-medium">
                    {type} {" "}
                    {coach.placement_ranks[index] && (
                      <span className="text-primary">
                        {parseInt(coach.placement_ranks[index]).toLocaleString('tr-TR')}
                      </span>
                    )}
                  </span>
                </div>
              ))}
          </div>
          <div className={`flex items-center ${isMobile ? 'flex-col gap-2' : 'justify-between'} mt-4`}>
            <Button 
              variant="outline" 
              size={isMobile ? "sm" : "default"}
              className={`text-brand-primary border-brand-primary hover:bg-brand-primary/5 ${isMobile ? 'w-full' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                onSelect(coach);
              }}
            >
              <Info className="w-4 h-4 mr-1" />
              Detaylar
            </Button>
            {coach.monthly_price && coach.remaining_slots > 0 && (
              <div className={`text-right ${isMobile ? 'w-full text-center' : ''}`}>
                <span className={`font-semibold text-primary ${isMobile ? 'text-base' : 'text-lg'}`}>
                  {coach.monthly_price.toLocaleString('tr-TR')}₺
                </span>
                <span className={`${isMobile ? 'text-xs' : 'text-sm'} text-muted-foreground`}> /ay</span>
              </div>
            )}
            {coach.remaining_slots === 0 && (
              <div className={`text-right ${isMobile ? 'w-full text-center' : ''}`}>
                <span className={`text-muted-foreground ${isMobile ? 'text-xs' : 'text-sm'} italic`}>
                  Kontenjan doldu
                </span>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
